/* eslint-disable @typescript-eslint/no-explicit-any */
import { IVideo } from '@shared/interface/model.interface';
import { dbData } from './init.db.data';

// ********************************************************
// Table 'cachedVideo'
// ********************************************************

//************************************************************************************* SET
export const dbSetCachedVideo = (
  providedCachedVideo?: IVideo,
): Promise<number> => {
  if (providedCachedVideo) {
    return dbData.transaction(
      'rw',
      dbData.cachedVideo,
      dbData.program,
      async () => {
        const programs = await dbData.program.toArray();
        let videoSize = 0;
        for (const program of programs) {
          if (program.videos != null) {
            for (const video of program.videos) {
              if (video.id === providedCachedVideo.id) {
                videoSize =
                  (video.fileSize ?? 0) > (providedCachedVideo.fileSize ?? 0)
                    ? video.fileSize ?? 0
                    : providedCachedVideo.fileSize ?? 0;
              }
            }
          }
        }
        providedCachedVideo.fileSize = videoSize;
        return dbData.cachedVideo.put(providedCachedVideo);
      },
    );
  } else {
    return Promise.resolve(0);
  }
};

interface IDbSetVideoSize {
  videoId: number;
  size: number;
}
export const dbSetVideoSize = (params: IDbSetVideoSize) => {
  return dbData.transaction('rw', dbData.cachedVideo, () => {
    dbData.cachedVideo
      .where({ id: params.videoId })
      .modify({ fileSize: params.size });
  });
};

//************************************************************************************* GET
export const dbGetCachedVideos = (): Promise<IVideo[]> => {
  return dbData.transaction('r', dbData.cachedVideo, async () => {
    const videos = await dbData.cachedVideo.toArray();
    return videos.length > 0 ? videos : [];
  });
};

//************************************************************************************* DELETE

export const dbRemoveCachedVideo = (videoId: number): Promise<void> => {
  return dbData.transaction('rw', dbData.cachedVideo, async () => {
    await dbData.cachedVideo.where({ id: videoId }).delete();
  });
};

export const dbRemoveCachedVideos = (): Promise<void> => {
  return dbData.transaction('rw', dbData.cachedVideo, async () => {
    await dbData.cachedVideo.clear();
  });
};
